module.exports = __webpack_public_path__ + "static/media/cat.778e316f.jpg";